import { React, useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import "../App.css";
import { Icon } from "@iconify/react";
import { useUserAuth } from "../auth";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { saveAs } from "file-saver";

const Files = () => {
	const { logOut, user, uploadFile, url, progress, files, deleteFile } = useUserAuth();
	const navigate = useNavigate();
	const handleLogout = async () => {
		try {
			await logOut();
			navigate("/login");
		} catch (error) {
			toast.error(error.message);
		}
	};

	const [file, setFile] = useState(null);
	useEffect(() => {
		if (url) {
			setFile(null);
		}
	}, [url]);

	// const types = ["image/png", "image/jpeg", "file/pdf", "images/jpg", "image/svg"];
	const handleChange = async (e) => {
		let selected = e.target.files[0];
		if (selected) {
			setFile(selected);
			await uploadFile(selected);
		} else {
			setFile(null);
			toast.error("Please select a valid file.");
		}
	};

	// const handleDownload = (url, filename) => {
	// 	fetch(url, {
	// 		method: "GET",
	// 		mode: "no-cors",
	// 		headers: {
	// 			"Access-Control-Allow-Origin": "*",
	// 		},
	// 	}).then((response) => {
	// 		response.blob().then((blob) => {
	// 			console.log(blob);
	// 			let url = window.URL.createObjectURL(blob);
	// 			let a = document.createElement("a");
	// 			a.href = url;
	// 			console.log(a.href);
	// 			a.download = filename;
	// 			a.click();
	// 		});
	// 	});
	// };
	const handleDownload = (url, filename) => {
		saveAs(url, filename);
	};
	const hiddenFileInput = useRef(null);
	const handleTrigger = async (e) => {
		hiddenFileInput.current.click();
	};

	const Delete = (id) => (
		<>
			<p style={{ fontSize: "18px", color: "var(--clr-txt)", fontFamily: "Fredoka" }}>Are you sure you want to delete {id.name}?</p>
			<button style={{ outline: "none", border: "none", borderRadius: "4px", padding: "6px", color: "#ffffff", fontFamily: "Fredoka", background: "#1da1f2" }} onClick={() => deleteFile(id.id, id.name)}>
				Delete
			</button>
		</>
	);

	const Logout = () => (
		<>
			<p style={{ fontSize: "18px", color: "var(--clr-txt)", fontFamily: "Fredoka" }}>Are you sure you want to logout {user.displayName}?</p>
			<button style={{ outline: "none", border: "none", borderRadius: "4px", padding: "6px", color: "#ffffff", fontFamily: "Fredoka", background: "#1da1f2" }} onClick={() => handleLogout()}>
				Yes
			</button>
		</>
	);

	let images = [];
	for (let i = 0; i < files.length; i++) {
		images.push(
			<motion.div layout key={files[i].id} className="file">
				<motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.1 }} className="fileDiv">
					<img className="fileIcon" src="https://firebasestorage.googleapis.com/v0/b/space-73.appspot.com/o/word.png?alt=media" alt="file" />
					<p className="fileName">{files[i].name}</p>
					<div className="file-actions">
						<span>
							<Icon onClick={() => handleDownload(files[i].url, files[i].name)} style={{ color: "#53b8bb" }} icon="ic:round-download" />
						</span>
						<span>
							<Icon onClick={() => window.open(files[i].url)} icon="fluent:eye-16-filled" />
						</span>
						<span>
							<Icon
								style={{ color: "#ff4444" }}
								onClick={() => {
									toast(<Delete id={files[i].id} name={files[i].name} />);
								}}
								icon="majesticons:delete-bin"
							/>
						</span>
					</div>
				</motion.div>
			</motion.div>
		);
	}
	return (
		<>
			<input type="checkbox" id="check" />
			<div className="route-icons">
				<Link className="route-icon" to="/files">
					<Icon icon="vscode-icons:folder-type-images-opened" />
				</Link>
				<Link className="route-icon" to="/passwords">
					<Icon icon="logos:keycdn-icon" />
				</Link>
				<Link className="route-icon" to="/">
					<Icon icon="noto-v1:notebook" />
				</Link>
			</div>
			<motion.section initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ ease: "linear", duration: 0.08 }} style={{ alignItems: "flex-start", backgroundImage: `url("https://firebasestorage.googleapis.com/v0/b/space-73.appspot.com/o/files.svg?alt=media")`, backgroundSize: "500px" }}>
				{user != null && (
					<>
						<span className="logoutIcon">
							<Icon onClick={() => toast(<Logout />)} icon="majesticons:logout-half-circle" />
						</span>
						<span onClick={handleTrigger} className="uploadIcon">
							<Icon style={{ paddingLeft: "4px" }} icon="uil:file-upload-alt" />
						</span>
						{file && <motion.div className="progress-bar" initial={{ width: 0 }} animate={{ width: progress + "%" }}></motion.div>}
						<input ref={hiddenFileInput} style={{ display: "none" }} type="file" onChange={handleChange} />
						<div className="files">
							{images}
							{files.length === 0 && <div className="msgText">Your files are secure and are only visible to you.</div>}
						</div>
					</>
				)}
			</motion.section>
		</>
	);
};

export default Files;
